/**
 * Co-Founder badge helpers.
 *
 * The co-founder account is identified by the jobRole string set server-side
 * via the seed script. We do a case-insensitive "co-founder" + "furcare" check
 * so the badge works regardless of whether the DB value uses hyphens, middle
 * dots, or plain spaces (e.g. "Co Founder Furcare" vs "Co-Founder · Furcare").
 */

/** The canonical display string used by the seed script. */
export const CO_FOUNDER_JOB_ROLE = "Co-Founder · Furcare";

/**
 * Returns true if the given user/author object is the Furcare Co-Founder.
 * Tolerates "Co Founder Furcare", "Co-Founder · Furcare", "co founder furcare", etc.
 */
export const isCoFounder = (user) => {
  const jobRole = (user?.jobRole || "").toLowerCase();
  return (
    (jobRole.includes("co") && jobRole.includes("founder") && jobRole.includes("furcare"))
  );
};
